// extracted by mini-css-extract-plugin
export const rating = "Rating-module--rating--2E-ZY";
export const ratingScore = "Rating-module--ratingScore--15f-9";
export const fullStar = "Rating-module--fullStar--1zsN1";
export const emptyStar = "Rating-module--emptyStar--3bfWE";